module.exports = __webpack_public_path__ + "static/assets/df453aa5d5261433d9c105b94be71579.png";